import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { FC } from 'react'
import { TelescopeIcon } from 'src/components/icons/telescope'
import { Colors } from 'src/components/theme'

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 200px 32px;
`

const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 16px;
  max-width: 500px;
`

type InsightEmptyProps = {
  title?: string
  message: string
}

export const InsightEmpty: FC<InsightEmptyProps> = ({ message, title = 'No Data to Show' }) => {
  return (
    <Container>
      <Content>
        <TelescopeIcon size={52} color="rgba(133, 153, 174, 1)" />
        <Typography variant="header3" color={Colors.neutral700} align="center">
          {title}
        </Typography>
        <Typography variant="textmdm" color={Colors.neutral400} align="center">
          {message}
        </Typography>
      </Content>
    </Container>
  )
}
